freeShippingGoal.Currency = (function () {
  const moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class GiftCampaignManager {
  constructor(cartItems, getSectionsToRender) {
    this.getSectionsToRender = getSectionsToRender;
    this.cartItems = cartItems;
    if (!GiftCampaignManager.cartAddEventAdded) {
      document.addEventListener('cart:add', this.onCartAdd.bind(this));
      GiftCampaignManager.cartAddEventAdded = true;
    }
    if (!GiftCampaignManager.cartUpdateEventAdded) {
      document.addEventListener('cart:update', this.onCartUpdate.bind(this));
      GiftCampaignManager.cartUpdateEventAdded = true;
    }
  }

  onCartAdd(event) {
    if (!window.gift_campaigns) {
      return;
    }
    const giftCombinations = window.gift_campaigns.combinations;
    const selectedVariantId = parseInt(
      event.detail.productForm?.querySelector('[name=id]')?.value
    );

    let isEventProduct = giftCombinations.find((combination) =>
      combination?.eligible_variants.includes(selectedVariantId)
    );
    let secondaryCombinations = giftCombinations.filter(
      (combination) => combination?.gift_is_secondary == true
    );
    let secondaryVariantIds = [];

    secondaryCombinations.map((combination) => {
      secondaryVariantIds.push(...(combination?.gifts_variant_id || []));
    });

    let isEventProductSecondary = secondaryVariantIds.some(item => isEventProduct?.gifts_variant_id.includes(item));

    let giftVariantId = isEventProduct?.gifts_variant_id; // free item for selected product

    let giftVariantsId = isEventProduct?.gifts_variant_id; // free items for selected product
    const giftVariantsIdList = Object.values(giftVariantsId);

    // all free items from the combinations
    let giftVariantIds = giftCombinations.flatMap(
      (combination) => combination.gifts_variant_id
    );


    let cartContents = document.getElementById('CartDrawerContent')
      ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      : undefined;
    let cartHasFreeItem = this.isFreeGiftInCart(
      cartContents.items,
      giftVariantIds
    );
    let secondaryFreeProductInCart = secondaryCombinations.find(
      (combination) =>
        this.isFreeGiftInCart(cartContents.items, [
          combination.gifts_variant_id,
        ])
    );

    // if cart does not have the free product, add it    
    if (!cartHasFreeItem && isEventProduct) {
      this.handleGiftProduct(this.cartItems, giftVariantsIdList, false);
    }

    // if cart has a free product, but it is a secondary free product, and the new free product is a primary free product, remove the secondary free product and add the new primary free product
    if (
      cartHasFreeItem &&
      secondaryFreeProductInCart &&
      isEventProduct &&
      !isEventProductSecondary
    ) {
      this.handleGiftProduct(
        this.cartItems,
        giftVariantId,
        secondaryFreeProductInCart.gifts_variant_id
      );
    }
  }

  isFreeGiftInCart(cartItems, giftVariantIdsArr) {
    let cartItemsArr = cartItems.map((item) => item.id);
    // check cart items against free gift variant ids
    for (let ii = 0; ii < cartItemsArr.length; ii++) {
      for (let jj = 0; jj < giftVariantIdsArr.length; jj++) {
        if (cartItemsArr[ii] == giftVariantIdsArr[jj]) {
          return true;
        }
      }
    }
    return false;
  }

  onCartUpdate(event) {
    if (!window.gift_campaigns || event.detail.type == 'change') {
      return;
    }
    let cartState = event.detail.cartState;

    let giftsManuallyRemoved = false;
    if (sessionStorage.getItem('giftsManuallyRemoved')) {
      giftsManuallyRemoved = JSON.parse(
        sessionStorage.getItem('giftsManuallyRemoved')
      );
    }
    let cartItems = cartState.items;
    let cartVariantIds = cartItems.map((item) => item.variant_id);
    let giftCombinations = window.gift_campaigns.combinations;
    let allPrimaryCombinations = window.gift_campaigns.all_primary_combinations;
    let primaryEligibleVariants =
      window.gift_campaigns.primary_eligible_variants;
    let secondaryEligibleVariants =
      window.gift_campaigns.secondary_eligible_variants;
    let primaryGiftVariants = window.gift_campaigns.primary_gift_variants;

    let primaryCombinations = giftCombinations.filter(
      (combination) => combination.gift_is_secondary == false
    );
    let secondaryCombinations = giftCombinations.filter(
      (combination) => combination.gift_is_secondary == true
    );
    let primaryVariantInCart = primaryEligibleVariants.some((variant) =>
      cartVariantIds.includes(variant)
    );
    let secondaryVariantInCart = secondaryEligibleVariants.some((variant) =>
      cartVariantIds.includes(variant)
    );

    console.log("primaryVariantInCart", primaryVariantInCart);


    if (primaryVariantInCart) {
      let isOnePrimaryCombinationInCart = false;
      allPrimaryCombinations.forEach((combination) => {
        if (this.checkSubset(cartVariantIds, combination)) {
          isOnePrimaryCombinationInCart = true;
        }
      });

      if (!isOnePrimaryCombinationInCart) {
        let primaryGiftInCartToRemove = this.getMatchingItem(
          cartVariantIds,
          primaryGiftVariants
        );
        let primaryEligibleVariant = this.getMatchingItem(
          cartVariantIds,
          primaryEligibleVariants
        );


        let matchingPrimaryCombination = primaryCombinations.find(
          (combination) => {
            if (giftsManuallyRemoved) {
              return (
                combination.eligible_variants.some(item => primaryEligibleVariant.includes(item))
                && !giftsManuallyRemoved.some(item => combination.gifts_variant_id.includes(item))
              );
            } else {
              return combination.eligible_variants.some(item => primaryEligibleVariant.includes(item));
            }
          }
        );

        let primaryGiftVariantToAdd =
          matchingPrimaryCombination?.gifts_variant_id;

        if (primaryGiftVariantToAdd) {
          this.handleGiftProduct(
            this.cartItems,
            primaryGiftVariantToAdd,
            primaryGiftInCartToRemove
          );
        }
      } else {
        if (window.gift_campaigns.min_order_value) {
          let primaryGiftInCartToRemove = this.getMatchingItem(
            cartVariantIds,
            primaryGiftVariants
          );
          let primaryGiftInCartPrice = cartState.items.find(item => item.id == primaryGiftInCartToRemove)?.final_line_price;
          let cartTotalWithoutGift = cartState.total_price - primaryGiftInCartPrice;
          if (cartTotalWithoutGift < window.gift_campaigns.min_order_value) {
            this.handleGiftProduct(
              this.cartItems,
              false,
              primaryGiftInCartToRemove
            );
          }
        }
      }
    }

    if (!primaryVariantInCart && secondaryVariantInCart) {
      // remove primary gift if any and add secondary gift
      let primaryGiftInCartToRemove = this.getMatchingItem(
        cartVariantIds,
        primaryGiftVariants
      );
      let secondaryEligibleVariant = this.getMatchingItem(
        cartVariantIds,
        secondaryEligibleVariants
      );
      let matchingSecondaryCombination = secondaryCombinations.find(
        (combination) => {
          if (giftsManuallyRemoved) {
            return (
              combination.eligible_variants.includes(
                secondaryEligibleVariant
              ) && !giftsManuallyRemoved.some(item => combination.gifts_variant_id.includes(item))
            );
          } else {
            return combination.eligible_variants.includes(
              secondaryEligibleVariant
            );
          }
        }
      );
      let secondaryGiftVariantToAdd =
        matchingSecondaryCombination?.gifts_variant_id;

      if (window.gift_campaigns.min_order_value) {
        let secondaryGiftInCartPrice = cartState.items.find(item => item.id == secondaryGiftVariantToAdd)?.final_line_price;
        let cartTotalWithoutGift = cartState.total_price - secondaryGiftInCartPrice;
        if (cartTotalWithoutGift < window.gift_campaigns.min_order_value) {
          this.handleGiftProduct(
            this.cartItems,
            false,
            secondaryGiftVariantToAdd
          );
        } else {
          if (secondaryGiftVariantToAdd) {
            this.handleGiftProduct(
              this.cartItems,
              secondaryGiftVariantToAdd,
              primaryGiftInCartToRemove
            );
          }
        }
      } else {
        if (secondaryGiftVariantToAdd) {
          this.handleGiftProduct(
            this.cartItems,
            secondaryGiftVariantToAdd,
            primaryGiftInCartToRemove
          );
        }
      }

    }

    if (!primaryVariantInCart && !secondaryVariantInCart) {
      // if none of the primary or secondary products are in the cart, remove the gift product if any
      let giftVariantInCartToRemove = this.getMatchingItem(
        cartVariantIds,
        window.gift_campaigns.all_gift_variants
      );
      console.log(giftVariantInCartToRemove);

      this.handleGiftProduct(
        this.cartItems,
        false,
        giftVariantInCartToRemove
      );
    }
  }

  handleGiftProduct(cartItems, giftVariantIdToAdd, giftVariantIdToRemove) {
    let data = {
      sections: 'cart-drawer,cart-icon-bubble',
      updates: {},
    };

    let cartContents = document.getElementById('CartDrawerContent')
      ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      : undefined;

    if (giftVariantIdToAdd && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value <= cartContents.total_price))) {
      (Array.isArray(giftVariantIdToAdd) ? giftVariantIdToAdd : [giftVariantIdToAdd])
        .forEach((key) => {
          data.updates[key] = 1;
        });
    }

    if (giftVariantIdToRemove) {
      (Array.isArray(giftVariantIdToRemove) ? giftVariantIdToRemove : [giftVariantIdToRemove])
        .forEach((key) => {
          data.updates[key] = 0;
        });
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(data);
    config.method = 'POST';

    fetch(`${routes.cart_update_url}`, config)
      .then((res) => res.json())
      .then((res) => {
        console.log("Gift script of handleGiftProduct fetch", res);

        cartItems.renderContents(res);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  checkSubset(parentArray, subsetArray) {
    return subsetArray.every((el) => {
      return parentArray.includes(el);
    });
  }

  getMatchingItem(array1, array2) {
    const set2 = new Set(array2);
    const matchingItems = array1.filter(item => set2.has(item));
    return matchingItems.length > 0 ? matchingItems : false;
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.giftCampaignManager = new GiftCampaignManager(this);
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initializeCartCheck();
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    let allCartItems = (document.querySelector('cart-items')) ? Array.from(document.querySelector('cart-items').querySelectorAll('.cart-item')) : Array.from(this.querySelectorAll('.cart-item'));
    const giftBag = allCartItems.find((element) => element.dataset.type == 'gift-bag');

    let cartWeight = Number(this.dataset.cartWeight);
    let giftBigBag = this.dataset.giftBagBig;
    let giftSmallBag = (this.dataset.giftBagSmall != '') ? this.dataset.giftBagSmall : giftBigBag;

    let bagToAdd = (cartWeight <= 750) ? giftSmallBag : ((giftBigBag != '') ? (giftBigBag) : (giftSmallBag));
    let bagToRemove = (cartWeight <= 750 && giftBigBag != giftSmallBag) ? giftBigBag : giftSmallBag;

    if (giftBag && giftBag.dataset.itemId != bagToAdd && giftBag.dataset.component == 'false') {
      setTimeout(() => {
        this.addGiftBag(this, bagToAdd, bagToRemove);
        console.log('Gift bag added');

      }, 1000);
    }
  }

  initializeCartCheck() {
    setTimeout(() => {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
          const result = data.items.filter((item) => item.vendor == "Additional service");
          const giftSmallBag = data.items.find((item) => item.sku == "BRO010-30x13x25-P-BAG-S1");
          const giftBigBag = data.items.find((item) => item.sku == "BRO010-39x35x17,5 -P-BAG-S1");

          if (result.length === data.item_count && data.item_count > 0) {
            if (document.querySelector('cart-items')) {
              document.querySelector('cart-items').cartClear();
            } else {
              this.cartClear();
            }
          }
          if (giftSmallBag && data.item_count == 1 && !giftSmallBag.properties._fromDefaultForm || giftBigBag && data.item_count == 1 && !giftBigBag.properties._fromDefaultForm) {
            if (document.querySelector('cart-items')) {
              document.querySelector('cart-items').cartClear();
            } else {
              this.cartClear();
            }
          }
        });
    }, 300);
  }

  addGiftBag(cart, giftVariantIdToAdd, giftVariantIdToRemove) {
    let section = this.getSectionsToRender().map((section) => section.section);

    if (window.location.pathname.includes('/cart')) {
      let cartItemsId = document.getElementById('main-cart-items').dataset.id;
      let giftWrapper = document.getElementById('gift-bag-wrapper');
      section = section + `,${cartItemsId}` + `,${giftWrapper}`;
    }

    let data = {
      sections: section,
      updates: {}
    };

    if (giftVariantIdToAdd) {
      data.updates[giftVariantIdToAdd] = 1;
    }

    if (giftVariantIdToRemove) {
      data.updates[giftVariantIdToRemove] = 0;
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(data);
    config.method = 'POST';

    fetch(`${routes.cart_update_url}`, config)
      .then((res) => res.json())
      .then((res) =>
        this.renderContents(res)
      )
      .catch((e) => {
        console.error(e);
      });
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
    const cartUpdateEvent = new CustomEvent('cart:update', {
      detail: event
    });
    document.dispatchEvent(cartUpdateEvent);
    document.dispatchEvent(new CustomEvent('cross-sell:trigger'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-sidebar',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart-sidebar .js-contents',
      },
      {
        id: 'gift-bag-wrapper',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.gift-bag-wrapper .js-contents',
      },
      {
        id: 'CartDrawerMain',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }

  cartClear() {
    let section = this.getSectionsToRender().map((section) => section.section);

    let data = {
      sections: section,
      updates: {},
    };

    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then(response => {
        setTimeout(() => {
          this.renderContents(response)
        }, 100);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  renderContents(parsedState) {
    if (parsedState.item_count == 0) {
      document.querySelector('cart-drawer').classList.add('is-empty');
      document.querySelector('cart-items')?.classList.add('is-empty');
      document.querySelector('#gift-bag-wrapper')?.classList.add('hidden');
    }
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id) && document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id) && document.getElementById(section.id);

      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
      }
    });
    cartdrawerFreeShippingNote();
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    /* Gift script - check if removed item is a gift */
    let lineToRemove, lineIsGiftVariantId, lineIsGift;
    if (window.gift_campaigns) {
      lineToRemove =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      // if customer manually removes the gift product, add it to sessionStorage array so it can't be added back to cart again automatically
      lineIsGiftVariantId = parseInt(lineToRemove.dataset.itemId);
      lineIsGift =
        window.gift_campaigns.all_gift_variants.includes(lineIsGiftVariantId);
      if (lineIsGift && quantity == 0) {
        let giftsManuallyRemoved = sessionStorage.getItem(
          'giftsManuallyRemoved'
        );
        if (giftsManuallyRemoved) {
          if (!giftsManuallyRemoved.includes(lineIsGiftVariantId)) {
            let giftsManuallyRemovedArray = JSON.parse(giftsManuallyRemoved);
            giftsManuallyRemovedArray.push(
              parseInt(lineToRemove.dataset.itemId)
            );
            sessionStorage.setItem(
              'giftsManuallyRemoved',
              JSON.stringify(giftsManuallyRemovedArray)
            );
          }
        } else {
          sessionStorage.setItem(
            'giftsManuallyRemoved',
            JSON.stringify([parseInt(lineToRemove.dataset.itemId)])
          );
        }
      }
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector('.drawer__inner-empty'),
            cartDrawerWrapper.querySelector('a')
          );
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector('.cart-item__name')
          );
        }
        this.disableLoading();
        cartdrawerFreeShippingNote();

        const event = new CustomEvent('cart:update', {
          detail: {
            cartState: parsedState,
          }
        });
        document.dispatchEvent(event);
        document.dispatchEvent(new CustomEvent('cross-sell:trigger'));
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden')
        );
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      defaultLabel: ".free-shipping-goal__label--default",
      successLabel: ".free-shipping-goal__label--success",
      progressBarContainer: ".progress-bar-container",
      shippingIconTemplate: "#fs-template-icon-shipping",
      giftIconTemplate: "#fs-template-icon-gift",
    };

    this.progressBarContainer = this.querySelector(
      this.selectors.progressBarContainer
    );
    this.defaultLabel = this.querySelector(this.selectors.defaultLabel);
    this.successLabel = this.querySelector(this.selectors.successLabel);
    this.moneyFormat = window.freeShippingGoal?.settings?.moneyFormat || "{{amount}}";
    this.currencyRate = Number(window.Shopify?.currency?.rate || 1);

    const shippingThreshold = Number(this.dataset.shippingThresholdCents) || 0;
    const giftOneThreshold = Number(this.dataset.giftOneThresholdCents) || 0;
    const giftTwoThreshold = Number(this.dataset.giftTwoThresholdCents) || 0;
    const giftThreeThreshold = Number(this.dataset.giftThreeThresholdCents) || 0;
    const giftFourThreshold = Number(this.dataset.giftFourThresholdCents) || 0;
    const giftFiveThreshold = Number(this.dataset.giftFiveThresholdCents) || 0;
    const giftSixThreshold = Number(this.dataset.giftSixThresholdCents) || 0;
    const giftSevenThreshold = Number(this.dataset.giftSevenThresholdCents) || 0;
    const giftEightThreshold = Number(this.dataset.giftEightThresholdCents) || 0;
    const barFullWidth = Number(this.dataset.barFullWidth) || 0;

    let freeShippingIcon = `<img class="progress-bar-icon" src="${this.dataset.freeShippingIcon}" alt="Free shipping icon" />` || null;
    let giftIcon = `<img class="progress-bar-icon" src="${this.dataset.giftIcon}" alt="Gift icon" />` || null;

    this.goals = [];

    if (shippingThreshold > 0) {
      this.goals.push({
        type: "shipping",
        amount: shippingThreshold,
        name: this.dataset.freeShippingName || window.freeShippingGoal?.strings?.freeShipping || "Doprava zdarma",
        icon: freeShippingIcon,
      });
    }

    if (giftOneThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftOneThreshold,
        name: this.dataset.giftOneName || window.freeShippingGoal?.strings?.freeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftTwoThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftTwoThreshold,
        name: this.dataset.giftTwoName || window.freeShippingGoal?.strings?.anotherFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftThreeThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftThreeThreshold,
        name: this.dataset.giftThreeName || window.freeShippingGoal?.strings?.thirdFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }
    
    if (giftFourThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftFourThreshold,
        name: this.dataset.giftFourName || window.freeShippingGoal?.strings?.fourthFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftFiveThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftFiveThreshold,
        name: this.dataset.giftFiveName || window.freeShippingGoal?.strings?.fifthFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftSixThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftSixThreshold,
        name: this.dataset.giftSixName || window.freeShippingGoal?.strings?.sixthFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftSevenThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftSevenThreshold,
        name: this.dataset.giftSevenName || window.freeShippingGoal?.strings?.seventhFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }

    if (giftEightThreshold > 0) {

      this.goals.push({
        type: "gift",
        amount: giftEightThreshold,
        name: this.dataset.giftEightName || window.freeShippingGoal?.strings?.eighthFreeGift || "Dárek zdarma",
        icon: giftIcon,
      });
    }
    
    if (barFullWidth > 0) {
      this.goals.push({
        type: "bar",
        amount: barFullWidth,
        name: "",
      });
    }

    this.goals.sort((a, b) => a.amount - b.amount);
    this.highestGoalAmount =
      this.goals.length > 0 ? this.goals[this.goals.length - 1].amount : 0;

    this.setupSegmentedBar();
    
    this.resolveSpecificOverlaps();
  }

  isOverlapping(el1, el2) {
    const r1 = el1.getBoundingClientRect();
    const r2 = el2.getBoundingClientRect();
    return !(
      r1.right <= r2.left ||
      r1.left >= r2.right ||
      r1.bottom <= r2.top ||
      r1.top >= r2.bottom
    );
  }

  resolveSpecificOverlaps() {
    const thresholdText1  = document.querySelector('.threshold-text--0');
    const thresholdText2 = document.querySelector('.threshold-text--1');
    const thresholdText3 = document.querySelector('.threshold-text--2');

    if (!thresholdText1 || !thresholdText2 || !thresholdText3) {
      return;
    }

    [thresholdText1, thresholdText2, thresholdText3].forEach(thresholdText => {
      thresholdText.style.left = '';
      thresholdText.style.right = '';
    });

    if (this.isOverlapping(thresholdText1, thresholdText2)) {
      thresholdText1.style.right = '0';
      thresholdText1.style.textAlign = 'right';
      thresholdText1.style.left = '';
    }

    if (this.isOverlapping(thresholdText2, thresholdText3)) {
      thresholdText3.style.left = '0';
      thresholdText3.style.textAlign = 'left';
      thresholdText3.style.right = '';
    }
  }

  connectedCallback() {
    this.updateShippingGoal(Number(this.dataset.cartTotalCents) || 0);

    document.addEventListener("cart:updated", (event) => {
      const cartTotalCents =
        event.detail?.cart?.items_subtotal_price ??
        event.detail?.cart?.total_price ??
        0;
      this.updateShippingGoal(cartTotalCents);
    });

    document.addEventListener("currency:update", () => {
      this.currencyRate = Number(window.Shopify?.currency?.rate || 1);
      this.updateShippingGoal(Number(this.dataset.cartTotalCents) || 0);
    });
  }

  setupSegmentedBar() {
    this.progressBarContainer.innerHTML = "";
    this.progressBarContainer.style.display = "flex";

    if (this.highestGoalAmount <= 0 || this.goals.length === 0) return;

    const barIconTemplate = document.getElementById("fs-template-icon-bar");

    let prevGoalAmount = 0;

    this.goals.forEach((goal, index) => {

      const segmentEndAmount = goal.amount;
      const segmentRange = segmentEndAmount - prevGoalAmount;

      const segmentWidthPercent = (index > 0) ? (segmentRange / this.highestGoalAmount) * 200 : (segmentRange / this.highestGoalAmount) * 100;

      if (segmentWidthPercent <= 0) {
        prevGoalAmount = segmentEndAmount;
        return;
      }

      const segmentContainer = document.createElement("div");
      segmentContainer.classList.add("segment-container");
      segmentContainer.dataset.segmentGoalAmount = segmentEndAmount;
      segmentContainer.style.flexBasis = `${segmentWidthPercent}%`;
      segmentContainer.style.webkitFlexBasis = `${segmentWidthPercent}%`;

      const segmentFill = document.createElement("div");
      segmentFill.classList.add("segment-fill");
      segmentFill.style.width = "0%";
      segmentContainer.appendChild(segmentFill);

      this.progressBarContainer.appendChild(segmentContainer);

      const markerPercent = (segmentEndAmount / this.highestGoalAmount) * 100;

      if (goal.type !== "bar") {
        const visualWrapper = document.createElement("div");
        visualWrapper.classList.add("threshold-visual-wrapper");
        visualWrapper.dataset.thresholdAmount = segmentEndAmount;

        let iconTemplateToClone = null;
        if (barIconTemplate) {
          iconTemplateToClone = barIconTemplate;
        }

        if (iconTemplateToClone) {
          const iconElement = iconTemplateToClone.cloneNode(true);
          iconElement.removeAttribute("id");
          visualWrapper.appendChild(iconElement);
        }

        const textElement = document.createElement("span");
        textElement.classList.add("threshold-text");
        textElement.classList.add(`threshold-text--${index}`);
        textElement.innerHTML = (this.goals.length <= 4) ? goal.name : goal.icon;
        visualWrapper.appendChild(textElement);

        visualWrapper.setAttribute(
          "title",
          `${goal.name} at ${freeShippingGoal.Currency.formatMoney(
            segmentEndAmount,
            this.moneyFormat
          )}`
        );

        this.progressBarContainer.appendChild(visualWrapper);
      }

      prevGoalAmount = segmentEndAmount;
    });
  }

  updateShippingGoal(cartTotalCents) {
    const currentTotalCents = cartTotalCents;
    const shippingThreshold = Number(this.dataset.shippingThresholdCents) || 0;
    const giftOneThreshold = Number(this.dataset.giftOneThresholdCents) || 0;
    const giftTwoThreshold = Number(this.dataset.giftTwoThresholdCents) || 0;
    const cartTotal = Number(this.dataset.cartTotal) || 0;

    if (currentTotalCents > 0 && this.highestGoalAmount > 0) {
      this.classList.remove("hidden");
    } else {
      this.classList.add("hidden");
      this.defaultLabel.style.display = "none";
      this.successLabel.style.display = "none";
      return;
    }

    let nextGoal = null;
    for (const goal of this.goals) {
      if (currentTotalCents < goal.amount) {
        nextGoal = goal;
        break;
      }
    }

    if (nextGoal && nextGoal.type !== "bar") {
      const remainingCents = nextGoal.amount - currentTotalCents;
      const remainingFormatted = freeShippingGoal.Currency.formatMoney(
        remainingCents,
        this.moneyFormat
      );
      let message = "";

      if (nextGoal.type === "gift") {
        message = (
          window.freeShippingGoalstrings?.remaining_gift_html ||
          "Nakúpte ešte za {{ remaining_amount }} a získajte {{ gift_name }}!"
        )
          .replace("{{ remaining_amount }}", remainingFormatted)
          .replace("{{ gift_name }}", nextGoal.name);
      } else {
        message = (
          window.freeShippingGoalstrings?.remaining_html ||
          "Nakúpte ešte za {{ remaining_amount }} a získajte {{ goal_name }}!"
        )
          .replace("{{ remaining_amount }}", remainingFormatted)
          .replace("{{ goal_name }}", nextGoal.name);
      }

      if (cartTotal > giftTwoThreshold && giftTwoThreshold > 0) {
        message = window.freeShippingGoalstrings?.second_gift_achieved_html + message;
      } else if (cartTotal > shippingThreshold && shippingThreshold > 0) {
        message = window.freeShippingGoalstrings?.first_shipping_achieved_html + message;
      } else if (cartTotal > giftOneThreshold && giftOneThreshold > 0) {
        message = window.freeShippingGoalstrings?.first_gift_achieved_html + message;
      }

      this.defaultLabel.innerHTML = message;
      this.defaultLabel.style.display = "";
      this.successLabel.style.display = "none";
      this.classList.remove("free-shipping-goal--done");
    } else {
      this.defaultLabel.style.display = "none";
      this.successLabel.innerHTML =
        window.freeShippingGoalstrings?.congratulations_html ||
        "Získali jste všechny výhody!";
      this.successLabel.style.display = "";
      this.classList.add("free-shipping-goal--done");
    }

    let prevGoalAmount = 0;
    this.goals.forEach((goal) => {
      const segmentEndAmount = goal.amount;
      const segmentContainer = this.progressBarContainer.querySelector(
        `.segment-container[data-segment-goal-amount="${segmentEndAmount}"]`
      );

      if (segmentContainer) {
        const segmentFill = segmentContainer.querySelector(".segment-fill");
        if (segmentFill) {
          const segmentRange = segmentEndAmount - prevGoalAmount;
          const progressInSegment = Math.max(
            0,
            currentTotalCents - prevGoalAmount
          );
          let segmentFillPercent = 0;

          if (segmentRange > 0) {
            segmentFillPercent = Math.min(
              100,
              (progressInSegment / segmentRange) * 100
            );
          } else {
            segmentFillPercent =
              currentTotalCents >= segmentEndAmount ? 100 : 0;
          }

          segmentFill.style.width = `${segmentFillPercent}%`;
        }
      }

      prevGoalAmount = segmentEndAmount;
    });

    this.goals.forEach((goal) => {
      const visualWrapper = this.progressBarContainer.querySelector(
        `.threshold-visual-wrapper[data-threshold-amount="${goal.amount}"]`
      );

      if (visualWrapper) {
        if (currentTotalCents >= goal.amount) {
          visualWrapper.classList.add("threshold--achieved");
        } else {
          visualWrapper.classList.remove("threshold--achieved");
        }

        if (this.querySelector(".progress-bar-gift-success")) {
          if (goal.type == "gift" && currentTotalCents >= goal.amount) {
            this.querySelector(".progress-bar-gift-success").style.display =
              "block";
          }
          if (goal.type == "gift" && currentTotalCents < goal.amount) {
            this.querySelector(".progress-bar-gift-success").style.display =
              "none";
          }
        }
      }
    });
  }
}

if (!customElements.get("free-shipping-goal")) {
  customElements.define("free-shipping-goal", FreeShippingGoal);
}

class cartDiscounts extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.cart-discounts-input');
    this.apply = this.querySelector('.cart-discounts-apply');
    this.removeDiscounts = this.querySelectorAll('.cart-discounts-item-remove');
    this.removeDiscounts.forEach(discount => {
      discount.addEventListener('click', this.removeDiscount.bind(this));
    });
    if (this.apply) {
      this.apply.addEventListener('click', () => this.updateCartDiscounts(this.input.value));
    }
  }

  removeDiscount(event) {
    const button = event.target.closest('button');
    if (!button) return;
    const discountTarget = button.dataset.discount;
    fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }
      return response.json();
    })
    .then(cart => {
      const appliedDiscounts = cart.discount_codes || [];
      const filteredDiscounts = appliedDiscounts.filter(discount => 
        discount.code.toLowerCase() !== discountTarget.toLowerCase()
      );
      const remainingDiscountCodes = filteredDiscounts.map(d => d.code).join(',');
      this.updateCartDiscounts(remainingDiscountCodes, appliedDiscounts);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  updateCartDiscounts(discount, existingDiscounts = null) {
    const section = (window.location.pathname.includes('/cart')) ? document.querySelector('cart-items').getSectionsToRender().map((section) => section.section) : document.querySelector('cart-drawer-items').getSectionsToRender().map((section) => section.section);
    
    const isRemoveOperation = existingDiscounts !== null;
    
    let data = {
      discount: discount,
      sections: section
    };

    if (this.apply) {
      this.apply.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.apply.querySelector('span').classList.add('hidden');
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(data);
    config.method = 'POST';
    
    fetch(`${routes.cart_update_url}`, config)
      .then((res) => res.json())
      .then((res) => {
        const appliedDiscounts = res.discount_codes || [];
        
        // For add operations, check if the new discount is applicable
        if (!isRemoveOperation) {
          const filteredDiscounts = appliedDiscounts.filter(d => 
            d.code.toLowerCase() === discount.toLowerCase()
          );
          
          if (filteredDiscounts.length > 0 && filteredDiscounts[0].applicable == false) {
            this.querySelector('.cart-discounts-error').classList.remove('hidden');
            this.apply.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.apply.querySelector('span').classList.remove('hidden');
            return;
          }
        }
        
        if (this.apply) {
          this.apply.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.apply.querySelector('span').classList.remove('hidden');
        }
        
        const cartItems = (window.location.pathname.includes('/cart')) ? document.querySelector('cart-items') : document.querySelector('cart-drawer-items');
        cartItems.renderContents(res);
      })
      .then(cart => {
        // Manually trigger the event if Shopify doesn't do it automatically
        Shopify?.PubSub?.publish('cart-update', cart);
      })
      .catch((e) => {
        console.error(e);
        if (this.apply) {
          this.apply.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.apply.querySelector('span').classList.remove('hidden');
        }
      });
  }
}

if (!customElements.get('cart-discounts')) {
  customElements.define('cart-discounts', cartDiscounts);
}